export const stateKey = reducer => Object.keys(reducer)[0];

export const createReducer = (initial, handlers) => (state = initial, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

export const getQueryValue = (key, url) => {
  let searchUrl = url ? url : window.location.search;
  return decodeURIComponent(searchUrl.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/\\/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

export const shuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const storeCityName = (cityName) => {
  let cities = JSON.parse(localStorage.getItem("tsCities"));
  for (let index = 0; index < cities.length; index++) {
    if (cities[index].name === cityName) {
      localStorage.setItem("currentCity", cityName);
      break;
    }
  }
}
export const getCityName = () => {
  return localStorage.getItem("currentCity");
}
export const getCityID = () => {
  let cities = JSON.parse(localStorage.getItem("tsCities"));
  let cityName = getCityName();
  for (let index = 0; index < cities.length; index++) {
    if (cities[index].name === cityName) {
      return cities[index].id;
    }
  }
}

export const createLinkTitle = title => title.replace(/[^\w\s]/gi, '').trim().toLowerCase().replace(/ {2}/g, " ").replace(/ /g, "-");
